/**
 * Conferences domain — admin UI registration (Sub-project III, Task 6).
 *
 * Injects per-record action toolbars into the generic-framework
 * detail pages via the `detailHeader` slot.
 */
import { registerAdminUI } from '@/admin/generic/registry';
import ConferenceActions from './components/ConferenceActions.vue';

registerAdminUI('conferences.conference', {
    slots: {
        detailHeader: ConferenceActions,
    },
});
